import { TenantName } from '@shared/models/tenant-name';
import { OverrideEnumArray } from '../../../../decorators';
import { PlatformID } from '..';

export class PaymentMessagesConfig {
    header = '';
    body = '';
    @OverrideEnumArray(PlatformID)
    allowPlatforms;
    @OverrideEnumArray(TenantName)
    allowTenants;
}
